import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import {
  Input, Select, Form, Row, Col, Checkbox,
} from 'antd';
import { useSelector } from 'react-redux';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {
  Currencies,
  PaymentMethods,
  ServiceTypes,
  TrafficTypes,
  CardTypes,
  Countries,
  RequestTypes,
  MidBanks,
} from '../../constants/System';

const { Option } = Select;
const formItemLayout = {
  labelCol: {
    span: 12,
  },
  wrapperCol: {
    span: 12,
  },
};

const ProcessorForm = ({
  form,
  handleChangeTrafficType,
  selectedTrafficTypes,
  handleChangeCardType,
  selectedCardTypes,
  handleChangeAllowedCountries,
  selectedAllowedCountries,
  handleChangeServiceType,
  selectedServiceType,
  handleChangeCurrency,
  selectedCurrency,
  handleChangePaymentMethod,
  selectedPaymentMethod,
  minimumAmount,
  maximumAmount,
  handleChange,
  newRecord,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const [midOperator, setMidOperator] = useState(false);
  const [midUsername, setMidUsername] = useState(false);
  const [midPassword, setMidPassword] = useState(false);

  const trafficTypeOptions = TrafficTypes
    && TrafficTypes.map((trafficType) => (
      <Option className="gx-text-capitalize" key={trafficType}>
        {trafficType}
      </Option>
    ));

  const serviceTypeOptions = ServiceTypes
    && ServiceTypes.map((serviceType) => (
      <Option className="gx-text-capitalize" key={serviceType}>
        {serviceType}
      </Option>
    ));


  const cardTypeOptions = CardTypes
  && CardTypes.map((cardType) => (
    <Option className="gx-text-capitalize" key={cardType}>
      {cardType}
    </Option>
  ));

  const midBankOptions = MidBanks
    && MidBanks.map((midBank) => (
      <Option key={midBank} value={midBank}>
        {midBank}
      </Option>
    ));

  const allowedCountryOptions = Countries
    && Countries.map((country) => (
      <Option className="gx-text-capitalize" key={country.iso2} value={country.iso2}>
        {`${country.name} (${country.iso2})`}
      </Option>
    ));

  const midCountryOptions = Countries
    && Countries.map((country) => (
      <Option className="gx-text-capitalize" key={country.iso3} value={country.iso3}>
        {`${country.name} (${country.iso3})`}
      </Option>
    ));

  const currencyOptions = Currencies
    && Currencies.map((currency) => (
      <Option className="gx-text-capitalize" key={currency}>
        {currency}
      </Option>
    ));

  const paymentMethodOptions = PaymentMethods
    && PaymentMethods.map((paymentMethod) => (
      <Option className="gx-text-capitalize" key={paymentMethod}>
        {paymentMethod}
      </Option>
    ));

  const requestTypeOptions = RequestTypes
    && RequestTypes.map(({ value, label }) => (
      <Option key={value} value={value}>
        {label}
      </Option>
    ));

  return (
    <Form name="basic" className="gx-form-row0" ref={form} {...formItemLayout}>
      <Row>
        <Col xl={15} lg={15} md={12} sm={24} xs={12}>
          <Form.Item
            rules={[{ required: true, message: 'This input is required!' }]}
            name="name"
            label="Mid Business Name"
          >
            <Input placeholder="Mid Business Name" />
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Service Type">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Select service type"
              value={selectedServiceType}
              onChange={handleChangeServiceType}
              showSearch
              optionFilterProp="children"
              filterOption={
                (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {serviceTypeOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Payment Method">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Select payment Method"
              value={selectedPaymentMethod}
              onChange={handleChangePaymentMethod}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {paymentMethodOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Currency">
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Select currency"
              value={selectedCurrency}
              onChange={handleChangeCurrency}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {currencyOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Allowed traffic">
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Select allowed traffic type"
              value={selectedTrafficTypes}
              onChange={handleChangeTrafficType}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {trafficTypeOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Allowed card types">
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Select allowed card type"
              value={selectedCardTypes}
              onChange={handleChangeCardType}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {cardTypeOptions}
            </Select>
          </Form.Item>
          <Form.Item rules={[{ required: false }]} label="Allowed countries">
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Select allowed countries (ISO2)"
              value={selectedAllowedCountries}
              onChange={handleChangeAllowedCountries}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {allowedCountryOptions}
            </Select>
          </Form.Item>
          {(authUser.role.name === 'AFFILIATE'
            || authUser.role.name === 'BUSINESS') && (
            <Form.Item
              label="Enable Affiliate"
              name="enable_affiliate"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          )}
          {newRecord && (
            <>
              <Form.Item name="mid_operator" label="Merchant Operator">
                <Input.Password
                  iconRender={(visible) => (visible ? (
                    <EyeTwoTone onClick={() => setMidOperator(false)} />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={() => setMidOperator(true)}
                    />
                  ))}
                  type={midOperator ? 'text' : 'password'}
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_username"
                label="Merchant Username"
              >
                <Input.Password
                  iconRender={(visible) => (visible ? (
                    <EyeTwoTone onClick={() => setMidUsername(false)} />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={() => setMidUsername(true)}
                    />
                  ))}
                  type={midUsername ? 'text' : 'password'}
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_password"
                label="Merchant Password"
              >
                <Input.Password
                  iconRender={(visible) => (visible ? (
                    <EyeTwoTone onClick={() => setMidPassword(false)} />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={() => setMidPassword(true)}
                    />
                  ))}
                  type={midPassword ? 'text' : 'password'}
                />
              </Form.Item>
            </>
          )}
          <>
              <Form.Item label="Is Aggregator Mid" name="mid_is_aggregator" valuePropName="checked">
                <Checkbox />
              </Form.Item>
              <Form.Item
                name="mid_id"
                label="Mid ID"
                tooltip="Unique numeric identifier for this MID. Leave blank to auto-generate."
                rules={[{ pattern: /^[0-9]*$/, message: 'Mid ID must be numeric!' }]}
              >
                <Input placeholder="Mid ID" />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_biz_name"
                label="Merchant Business Name"
              >
                <Input placeholder="Merchant Business Name" />
              </Form.Item>
              <Form.Item label="Merchant Bank" name="mid_bank">
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Select merchant bank"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {midBankOptions}
                </Select>
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_address1"
                label="Merchant Address 1"
              >
                <Input placeholder="Merchant Address 1" />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_locality"
                label="Merchant Locality"
              >
                <Input placeholder="Merchant Locality" />
              </Form.Item>

              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_city"
                label="Merchant City"
              >
                <Input placeholder="Merchant City" />
              </Form.Item>

              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_country"
                label="Merchant Country"
              >
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Select merchant country (ISO3)"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {midCountryOptions}
                </Select>
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_postal_code"
                label="Merchant Postal Code"
              >
                <Input placeholder="Merchant Postal Code" />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'This input is required!' }]}
                name="mid_category_code"
                label="Merchant Category Code"
              >
                <Input placeholder="Merchant Category Code" />
              </Form.Item>
          </>
          {(!authUser.role.name.includes('Merchant')) && (
            <>
              <Form.Item label="Is Production Mid" name="mid_is_production" valuePropName="checked">
                <Checkbox />
              </Form.Item>
              <Form.Item label="Mid URL" name="mid_url">
                <Input placeholder="Mid URL" />
              </Form.Item>
              <Form.Item
                label="Request Type"
                name="mid_request_type"
                initialValue="HPP"
                tooltip="How this mid/processor routes collection requests: hosted-page redirect or direct server-to-server"
              >
                <Select style={{ width: '100%' }} placeholder="Select request type">
                  {requestTypeOptions}
                </Select>
              </Form.Item>
            </>
          )}
          <Form.Item label="Processing Rank" name="rank" initialValue={1}>
            <Input placeholder="Rank" />
          </Form.Item>
          <Form.Item label="Reject First Time Depositors" name="deny_ftds" valuePropName="checked">
            <Checkbox />
          </Form.Item>
          <Form.Item label="Active" name="is_active" valuePropName="checked">
            <Checkbox />
          </Form.Item>
        </Col>
        <Col xl={9} lg={9} md={12} sm={24} xs={12}>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Acquirer/PSP Charge (Fixed)"
            name="processor_fixed_charge"
          >
            <Input placeholder="Acquirer/PSP Charge (Fixed)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Acquirer/PSP Charge (%)"
            name="processor_percentage_charge"
          >
            <Input placeholder="Acquirer/PSP Charge (%)" />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Our Charge (fixed)"
            name="p2p_fixed_charge"
          >
            <Input placeholder="Our Charge (fixed)" />
          </Form.Item>

          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Our Charge (%)"
            name="p2p_percentage_charge"
          >
            <Input placeholder="Our Charge (%)" />
          </Form.Item>
          <Form.Item
            label="Refund Fixed Charge"
            name="refund_charge"
            initialValue={0}
          >
            <Input placeholder="Refund Fixed Charge" />
          </Form.Item>
          <Form.Item
            label="Chargeback Fixed Charge"
            name="chargeback_charge"
            initialValue={0}
          >
            <Input placeholder="Chargeback Fixed Charge" />
          </Form.Item>
          <Form.Item
            label="Settlement Fixed Charge"
            name="settlement_charge"
            initialValue={0}
          >
            <Input placeholder="Settlement Fixed Charge" />
          </Form.Item>
          <Form.Item
            label="Currency Decimal Places"
            name="decimal_places"
            initialValue={0}
          >
            <Input placeholder="Currency Decimal Places" />
          </Form.Item>
          <Form.Item label="Minimum Amount">
            <Select
              name="minimum_amount"
              value={minimumAmount}
              onChange={(e) => handleChange(e, 'minimum_amount')}
            >
              <Option key={0}>0</Option>
              <Option key={1}>1</Option>
              <Option key={5}>5</Option>
              <Option key={10}>10</Option>
              <Option key={20}>20</Option>
              <Option key={50}>50</Option>
              <Option key={100}>100</Option>
              <Option key={200}>200</Option>
              <Option key={300}>300</Option>
              <Option key={400}>400</Option>
              <Option key={500}>500</Option>
              <Option key={1000}>1000</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Maximum Amount">
            <Select
              name="maximum_amount"
              value={maximumAmount}
              onChange={(e) => handleChange(e, 'maximum_amount')}
            >
              <Option key={0}>0</Option>
              <Option key={50}>50</Option>
              <Option key={100}>100</Option>
              <Option key={500}>500</Option>
              <Option key={1000}>1000</Option>
              <Option key={2000}>2000</Option>
              <Option key={3000}>3000</Option>
              <Option key={4500}>4500</Option>
              <Option key={5000}>5000</Option>
              <Option key={7000}>7000</Option>
              <Option key={9000}>9000</Option>
              <Option key={10000}>10000</Option>
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: 'This input is required!' },
            ]}
            label="Daily Transaction Limit"
            name="daily_limit_amount"
          >
            <Input placeholder="Daily Transaction Limit" />
          </Form.Item>
          <Form.Item label="Refundable" name="is_refundable" valuePropName="checked">
            <Checkbox />
          </Form.Item>
           <Form.Item label="Vip Only" name="vip_only" valuePropName="checked">
            <Checkbox />
          </Form.Item>
          <Form.Item label="Weekday Only" name="only_weekday" valuePropName="checked">
            <Checkbox />
          </Form.Item>
           <Form.Item label="Disable Descriptor" name="mid_disable_descriptor" valuePropName="checked">
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

ProcessorForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  handleChangeTrafficType: PropTypes.func.isRequired,
  selectedTrafficTypes: PropTypes.string.isRequired,
  handleChangeCardType: PropTypes.func.isRequired,
  selectedTrafficTypes: PropTypes.string.isRequired,
  handleChangeAllowedCountries: PropTypes.func.isRequired,
  selectedAllowedCountries: PropTypes.arrayOf(PropTypes.string),
  handleChangeServiceType: PropTypes.func.isRequired,
  selectedCurrency: PropTypes.string.isRequired,
  handleChangeCurrency: PropTypes.func.isRequired,
  selectedPaymentMethod: PropTypes.string.isRequired,
  handleChangePaymentMethod: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedServiceType: PropTypes.string.isRequired,
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
  newRecord: PropTypes.bool,
};

ProcessorForm.defaultProps = {
  form: {},
  minimumAmount: 0,
  maximumAmount: 0,
  newRecord: false,
};

export default ProcessorForm;
